export default __webpack_public_path__ + "static/media/prensesselin1.1b91fa41.jpg";